import { SESSION_KEY_REGION } from '../types/AppConfig';
import type { StoredRegion } from '../types/AppConfig';
import { getEnv } from '../config/env';

/**
 * Returns the standard V2 authentication headers required by the ResourceMigrator API.
 * The API uses CustomerAuthorizationV2, which requires:
 *   - Authorization: Bearer <token>
 *   - Edci-Application-Name: <app key>
 *   - Edci-Genesys-Region: <region, e.g. "us-west-2">
 */
export function getV2AuthHeaders(bearerToken: string): Record<string, string> {
  let region = '';
  const raw = sessionStorage.getItem(SESSION_KEY_REGION);
  if (raw) {
    try {
      const stored = JSON.parse(raw) as StoredRegion;
      region = stored.key.replace(/_/g, '-');
    } catch {
      // region stays empty — server will return 400 with a clear message
    }
  }
  return {
    Authorization: `Bearer ${bearerToken}`,
    'Edci-Application-Name': getEnv().VITE_APP_KEY,
    'Edci-Genesys-Region': region
  };
}
